if ( !customElements.get( 'read-more' ) )
{
	class ReadMore extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				content: '.read-more__content',
				button: '.read-more__toggle',
				buttonText: '.btn__text',
			};

			this.classes = {
				isDisabled: 'is-disabled',
				isCollapsed: 'is-collapsed',
			};

			this.abortController = new AbortController();

			this.toggleClass = this.dataset.toggleClass;
			this.showText = this.dataset.showText;
			this.hideText = this.dataset.hideText;
			this.lineClamp = parseInt(this.dataset.lineClamp);
			this.buttonEl = this.querySelector(this.selectors.button);
			this.contentEl = this.querySelector(this.selectors.content);

			this.buttonEl.addEventListener('click', this.onClick.bind(this), {
				signal: this.abortController.signal,
			});

			this.init();
		}

		init() {
			const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
			const contentHeight = this.contentEl.scrollHeight;
			const maxHeight = lineHeight * this.lineClamp;

			if (contentHeight <= maxHeight) {
				this.buttonEl.style.display = 'none';
				return;
			}

			this.classList.remove(this.classes.isDisabled);
			this.contentEl.classList.remove(this.toggleClass);
			this.showLess();
		}

		showMore() {
			this.contentEl.classList.remove(this.toggleClass);
			this.classList.remove(this.classes.isCollapsed);
			this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.hideText;
			this.resetHeight();
		}

		showLess() {
			this.contentEl.classList.add(this.toggleClass);
			this.classList.add(this.classes.isCollapsed);
			this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.showText;
			this.setHeight();
		}

		setHeight() {
			const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
			const lines = parseInt(window.getComputedStyle(this.contentEl).getPropertyValue('--line-clamp'));
			const maxHeight = lineHeight * lines;
			this.contentEl.style.setProperty('max-height', maxHeight + 'px');
		}

		resetHeight() {
			this.contentEl.style.removeProperty('max-height');
		}

		onClick(evt) {
			if (this.contentEl.classList.contains(this.toggleClass)) {
				this.showMore();
			} else {
				this.showLess();
			}
		}

		disconnectedCallback() {
			this.abortController.abort();
		}
	}
	customElements.define('read-more', ReadMore);
}